// extracted by mini-css-extract-plugin
module.exports = {"plan-block":"plan-block_1CpX","plan-list":"plan-list_1auK","plan-item":"plan-item_1fCB","active":"active_wIFi"};